import { render, staticRenderFns } from "./activaitor.vue?vue&type=template&id=7220adfc&"
import script from "./activaitor.vue?vue&type=script&lang=js&"
export * from "./activaitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports